import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  id: 1,
  src: 'https://cdn.magicpatterns.com/uploads/2pFVbA4TrC41QAa856QgMt/Testimonio%201.MOV',
  caption: 'Experiencia real de una persona que participó en la mentoría.'
}, {
  id: 2,
  src: 'https://cdn.magicpatterns.com/uploads/i8X1QF8rSWBxTjtJzTBU4A/Testimonio%202.MOV',
  caption: 'Experiencia real compartida por una participante.'
}];
export function Testimonials() {
  return <section className="py-24 md:py-32 bg-ink-light relative overflow-hidden" data-id="element-332" data-mp="31zwb37agx6h1">
      <div className="container mx-auto px-6" data-id="element-333" data-mp="321za2gtlm9xw">
        <motion.div className="text-center max-w-2xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-334" data-mp="2x006b5ty5b0f">
          <span className="text-gold tracking-[0.2em] text-xs md:text-sm font-semibold uppercase mb-4 block" data-id="element-335" data-mp="v7c6l6gih5pe">
            EXPERIENCIAS REALES
          </span>
          <h2 className="text-3xl md:text-5xl font-serif text-ivory-bright mb-6" data-id="element-336" data-mp="h4wysdjfawnh">
            Personas que decidieron dar el primer paso y compartir su experiencia.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-337" data-mp="7927yv51pv9m">
          {testimonials.map((t, index) => <motion.div key={t.id} className="flex flex-col items-center" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} data-id="element-338" data-mp="c8y09x4dry9c" data-mpi={index}>
              <div className="w-full relative overflow-hidden rounded-2xl bg-black/40 border border-white/10 h-[550px] flex items-center justify-center shadow-2xl mb-4" data-id="element-339" data-mp="q4s8edxbyjle">
                <video src={t.src} className="w-full h-full object-contain drop-shadow-lg" autoPlay muted loop playsInline controls data-id="element-340" data-mp="1itz8vigchj9a" />
              </div>
              <p className="text-muted text-sm font-light text-center italic px-4" data-id="element-341" data-mp="1sjfmb8mbv895">
                {t.caption}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}